import { BaseButton } from 'components/atoms/Button';

import styled from 'styled-components';

type ActionButtonProps = {
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  width?: number;
  height?: number;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const ActionButton = ({ disabled, children, className, width, height, onClick }: ActionButtonProps) => {
  return (
    <ActionButtonContainer
      disabled={disabled}
      tabIndex={0}
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      type="button"
    >
      {children}
    </ActionButtonContainer>
  );
};

const ActionButtonContainer = styled(BaseButton)<{ width?: number; height?: number; disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ width }) => (width ? `${width}px` : '40px')};
  height: ${({ height }) => (height ? `${height}px` : '40px')};
  border-radius: 4px;
  svg {
    flex-shrink: 0;
  }
  &:hover {
    background-color: ${({ theme }) => theme.createRGBAWithHex(theme.mantineColors.gray[8], 0.05)};
  }
  &:active {
    box-shadow: unset;
    background-color: ${({ theme }) => theme.createRGBAWithHex(theme.mantineColors.gray[8], 0.1)};
  }
  &:disabled {
    background-color: unset;
    cursor: not-allowed;
  }
`;

export default ActionButton;
